import { modularScale } from "polished";
import { theme } from "@chakra-ui/react";

/* eslint-disable sort-keys, no-magic-numbers */
import { ratio, s0 } from "./constants";
import colors from "./colors";


const borderWidths = {
    xsmall: `${modularScale(1, s0, ratio)}px`,
    small: `${modularScale(2, s0, ratio)}px`,
    medium: `${modularScale(3, s0, ratio)}px`,
    large: `${modularScale(6, s0, ratio)}px`,
    xlarge: `${modularScale(8, s0, ratio)}px`,
    2: "2px"
};

const borders = {
    underline: `${borderWidths.medium} solid`,
    dashed: `${borderWidths.medium} dashed`,
    xsmall: `${borderWidths.xsmall} solid`,
    small: `${borderWidths.small} solid`,
    medium: `${borderWidths.medium} solid`,
    large: `${borderWidths.large} solid`,
    xlarge: `${borderWidths.xlarge} solid`,
    timelineLine: `1px solid ${colors.secondary["100"]}`,
    thinLight: `1px solid ${colors.secondary?.["100"]}`
};
const borderStyles = {
    solid: "solid",
    dashed: "dashed"
};
const radii = {
    2: "2px",
    3: "3px",
    5: "5px",
    6: "6px",
    10: "10px",
    inputRoundCorner: "0.375rem",
    smallFlatButton: "0.25rem"
};

export default {
    borderWidths: {
        ...borderWidths
    },
    borders: {
        ...theme.borders,
        ...borders
    },
    borderStyles: {
        ...borderStyles
    },
    radii: {
        ...theme.radii,
        ...radii
    }
};

